module.exports = __webpack_public_path__ + "static/media/proces_04.06421344.svg";